import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Pains } from '../components/sections/Pains';
import { SystemIntro } from '../components/sections/SystemIntro';
import { Tomos } from '../components/sections/Tomos';
import { Bonuses } from '../components/sections/Bonuses';
import { Pricing } from '../components/sections/Pricing';
import { MegapackExtra } from '../components/sections/MegapackExtra';
import { Comparison } from '../components/sections/Comparison';
import { TestimonialsFull } from '../components/sections/TestimonialsFull';
import { Guarantee } from '../components/sections/Guarantee';
import { FAQ } from '../components/sections/FAQ';
import { Footer } from '../components/sections/Footer';
import { FloatingElements } from '../components/FloatingElements';
import { MetaPixel } from '../components/MetaPixel';
export const Landing = () => {
  return <div className="min-h-screen bg-gray-50 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-316">
      <MetaPixel data-id="element-317" />
      <Hero data-id="element-318" />
      <Pains data-id="element-319" />
      <SystemIntro data-id="element-320" />
      <Tomos data-id="element-321" />
      <Bonuses data-id="element-322" />
      <Pricing data-id="element-323" />
      <MegapackExtra data-id="element-324" />
      <Comparison data-id="element-325" />
      <TestimonialsFull data-id="element-326" />
      <Guarantee data-id="element-327" />
      <FAQ data-id="element-328" />
      <Footer data-id="element-329" />
    </div>;
};